import CONSTANTS from '@/constants'

export const PENDING_STATUS = CONSTANTS.GADAI.STATUS_DISBURSEMENT_PENDING
export const DISBURSE_STATUS = CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI

export function parseDocumentUrls(value) {
  if (!value) return []
  if (Array.isArray(value)) return value.filter(Boolean)
  return String(value).split(',').map(url => url.trim()).filter(Boolean)
}

export function toAmount(value) {
  return Number(value) || 0
}

export function getNominalGadai(detailGadai = {}) {
  return toAmount(detailGadai.pinjamanPokokAwal)
}

export function getTotalDiterimaNasabah(disbursementPending = {}) {
  return toAmount(disbursementPending.transferAmount)
}

export function getDiberikanTunai(disbursementPending = {}) {
  const transferAmount = getTotalDiterimaNasabah(disbursementPending)
  const maxCashAmount = toAmount(disbursementPending.maksPencairanDanaTunai)

  if (!maxCashAmount) return transferAmount
  return Math.min(transferAmount, maxCashAmount)
}

export function isFailedDisbursementWithoutStatement(transaction = {}, disbursementPending = {}) {
  return transaction.statusDisburse === DISBURSE_STATUS.DANA_DITANGGUHKAN_GAGAL
    && parseDocumentUrls(disbursementPending.pathFotoStatement).length === 0
}

export function isSuccessDisbursementWithoutStatement(transaction = {}, disbursementPending = {}) {
  return transaction.statusDisburse === DISBURSE_STATUS.DISBURSED
    && parseDocumentUrls(disbursementPending.pathFotoStatement).length === 0
}

export function getNominalKekurangan(transaction = {}, disbursementPending = {}) {
  if (isFailedDisbursementWithoutStatement(transaction, disbursementPending)) {
    return getTotalDiterimaNasabah(disbursementPending)
  }

  return Math.max(getTotalDiterimaNasabah(disbursementPending) - getDiberikanTunai(disbursementPending), 0)
}
